import { useState } from "react";
import { YearDDL } from "../../../../CommonDDL/YearDDL";
import { MonthDDL } from "../../../../CommonDDL/MonthDDL";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";
import { RubberSaplingsPostAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartThirdSlice";


const AddRubbersaplings = (props) => {


    const { handleAddrubbersaplings, DataIsPost,setDataIsPost, Title, Message,M_BeneficiaryDetailsID,T_BeneficiaryPlantationDetailsID } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [NoOfPlants,setNoOfPlants] = useState('')

    const [Year, setYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [MonthDDLID, setMonthDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const handleDataIsPost = () => {
        setDataIsPost(!DataIsPost)
        handleAddrubbersaplings()
        // handleShowDelete()
    }

    const handleSubmit = () => {
        const data = {
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            T_BeneficiaryPlantationDetailsID : T_BeneficiaryPlantationDetailsID,
            FinancialYearID:Year.ID,
            MonthsID:MonthDDLID.ID,
            NoOfPlants:NoOfPlants,
            M_TableUserMasterID: UserID,
            token: token,
            handleDataIsPost

        }
        // console.log("RawData",RawData)
        dispatch(RubberSaplingsPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.RubberSaplingsPostData)

    return (<>
        <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
            <div className="modal-dialog modal-xl" role="document"  >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title ml-lg-5" id="exampleModalLongTitle">{Title}</h5>
                        <button onClick={handleAddrubbersaplings} type="button" className="close" style={{ marginLeft: "auto" }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body" style={{ overflowY: 'scroll', height: '70vh' }}>
                        <div className="row">
                            <div className="col-12 col-lg-4 mx-auto">
                                <YearDDL
                                    Year={Year}
                                    setYear={setYear}
                                    apiFlag=''
                                    Flag=''
                                    data=''
                                    IsPost=''
                                />
                            </div>

                            <div className="col-12 col-lg-4 mx-auto">
                                <MonthDDL
                                    MonthDDLID={MonthDDLID}
                                    setMonthDDLID={setMonthDDLID}
                                    apiFlag=''
                                    Flag=''
                                    data=''
                                    IsPost=''
                                />
                            </div>

                            <div className="col-12 col-lg-4 mx-auto ">
                                <span className="fw-bold">No of Plants</span>
                                <input

                                    type="text"
                                    className="form-control mt-2 "
                                    name="DepartmentName"
                                    placeholder="type here"
                                    value={NoOfPlants}
                                    onChange={(e)=>setNoOfPlants(e.target.value)}

                                />
                            </div>

                            <div className="col-12 col-lg-4 mx-auto pt-5 ">
                                <div className="form-group w-80 d-flex justify-content-center">
                                    <button
                                        type='button'
                                        onClick={handleSubmit}
                                        className="btn bg-success text-white border-2 mx-2 px-4" data-ktwizard-type="action-next">
                                        Add
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleAddrubbersaplings}
                                        className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                        Close
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default AddRubbersaplings;